import { createActionGroup, emptyProps, props } from '@ngrx/store';
import { HubNotification, UserHubNotification, CreateNotificationRequest, UpdateNotificationRequest } from '@models/notification.model';

export const NotificationsAdminActions = createActionGroup({
  source: 'Notifications Admin',
  events: {
    'Load Notifications': props<{ showInactive: boolean }>(),
    'Load Notifications Success': props<{ notifications: HubNotification[] }>(),
    'Load Notifications Failure': props<{ error: string }>(),

    'Create Notification': props<{ request: CreateNotificationRequest }>(),
    'Create Notification Success': props<{ notification: HubNotification }>(),
    'Create Notification Failure': props<{ error: string }>(),

    'Update Notification': props<{ request: UpdateNotificationRequest }>(),
    'Update Notification Success': props<{ notification: HubNotification }>(),
    'Update Notification Failure': props<{ error: string }>(),

    'Delete Notification': props<{ id: number }>(),
    'Delete Notification Success': props<{ id: number }>(),
    'Delete Notification Failure': props<{ error: string }>(),

    'Reactivate Notification': props<{ id: number }>(),
    'Reactivate Notification Success': props<{ id: number }>(),
    'Reactivate Notification Failure': props<{ error: string }>(),

    'Set Show Inactive': props<{ showInactive: boolean }>(),
  },
});

export const NotificationsUserActions = createActionGroup({
  source: 'Notifications User',
  events: {
    'Load User Notifications': emptyProps(),
    'Load User Notifications Success': props<{ notifications: UserHubNotification[] }>(),
    'Load User Notifications Failure': props<{ error: string }>(),

    'Mark Notification Read': props<{ id: number }>(),
    'Mark Notification Read Success': props<{ id: number }>(),
    'Mark Notification Read Failure': props<{ error: string }>(),

    'Mark Notification Unread': props<{ id: number }>(),
    'Mark Notification Unread Success': props<{ id: number }>(),
    'Mark Notification Unread Failure': props<{ error: string }>(),

    'Welcome Modal Shown': emptyProps(),
  },
});
